import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createSlots as _createSlots, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-83fbb600"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  id: "benefits",
  class: "mx-auto wrapper"
};

const _hoisted_2 = /*#__PURE__*/_createTextVNode("專屬 Demi Trader 賦能通行證");

const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "sub-landing-title lh-base"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "text-white font-h5 lh-base"
}, "持有 NFT 享有多重通路優惠")], -1));

const _hoisted_4 = {
  class: "card-list d-flex flex-wrap"
};

const _hoisted_5 = /*#__PURE__*/_createTextVNode(" 可於全台");

const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  class: "text-white",
  href: "#"
}, "Demi-Boss 商家地圖", -1));

const _hoisted_7 = /*#__PURE__*/_createTextVNode("享有專屬 Demi 的商家優惠 ");

import feature1 from "@/assets/master-link/feature-1.png";
import feature2 from "@/assets/master-link/feature-2.png";
import feature3 from "@/assets/master-link/feature-3.png";
import feature4 from "@/assets/master-link/feature-4.png";
import feature5 from "@/assets/master-link/feature-5.png";
import feature6 from "@/assets/master-link/feature-6.png";
export default {
  __name: 'DemiHumanBenefitsBlock',

  setup(__props) {
    const list = [{
      image: feature1,
      title: '01. 專屬角色稱號',
      desc: '於 Demi Discord 取得專屬DemiPASS Role 角色稱號'
    }, {
      image: feature2,
      title: '02. 免費 Web3 學習課程',
      desc: '於 Demi Discord 即可參與 Demi-Academy Web3 系統化的學習課程'
    }, {
      image: feature3,
      title: '03. 專屬投資討論社群',
      desc: '於 Demi Discord 即可參與各式投資討論群：NFT、美股、台股、加密貨幣'
    }, {
      image: feature4,
      title: '04. 全台 50 + 商家優惠'
    }, {
      image: feature5,
      title: '05. 多元豐富的社群活動',
      desc: '超級豐富的線上語音主題內容與線下團遊'
    }, {
      image: feature6,
      title: '06. Web3 導向',
      desc: '你將擁有一群 Web3 的家人 Demily'
    }];
    return (_ctx, _cache) => {
      const _component_landing_title = _resolveComponent("landing-title");

      const _component_feature_badge_card = _resolveComponent("feature-badge-card");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_landing_title, null, {
        default: _withCtx(() => [_hoisted_2]),
        _: 1
      }), _hoisted_3, _createElementVNode("div", _hoisted_4, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(list, (item, index) => {
        return _createElementVNode("div", {
          key: index,
          class: "card-wrapper"
        }, [_createVNode(_component_feature_badge_card, {
          badgeUrl: item.image
        }, _createSlots({
          title: _withCtx(() => [_createTextVNode(_toDisplayString(item.title), 1)]),
          _: 2
        }, [index === 3 ? {
          name: "desc",
          fn: _withCtx(() => [_hoisted_5, _hoisted_6, _hoisted_7])
        } : {
          name: "desc",
          fn: _withCtx(() => [_createTextVNode(_toDisplayString(item.desc), 1)])
        }]), 1032, ["badgeUrl"])]);
      }), 64))])]);
    };
  }

};